import { DeleteOutlined, PlusOutlined, ToTopOutlined } from "@ant-design/icons";
import { Button, DatePicker, Input, Select, Table, Typography } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { KEY, lang, MODE_SCREEN, STYLE } from "../../constants/common.const";
import { ButtonModalClassification } from "./buttonModalClassification";
import classDdl from "../../models/control/dropdownlist";
import API from "../../api/backend/machineManagement";
import { filterEmptyDataSource, isEmptyData } from "../../utils/helper";

const { Text } = Typography;
const EquipmentRepairPlan = ({
  mode = MODE_SCREEN.VIEW,
  data = {},
  dataSource: listPlanMaintenance = [],
  setDataSource: setListPlanMaintenance = () => {},
  handleAddRowMaintaince,
  clickSave,
  ddlClassification,
  setDdlClassification,
  setIsDirty,
  currentGene
}) => {
  const optionRepair = [
    { value: "0", label: "セットなし" },
    { value: "3", label: "3か月" },
    { value: "6", label: "6か月" },
    { value: "12", label: "1年" },
  ];
  const { allowRoute, roles } = useSelector((state) => state.auth);
  const isViewMode = mode === MODE_SCREEN.VIEW;
  const handleDeleteRowPlanMaintaince = (key) => {
    const newListAttachMachine = listPlanMaintenance.filter((item) => {
      return item.key !== key;
    });
    setListPlanMaintenance(newListAttachMachine);
    setIsDirty(true)
  };
  const onChangePlanMaintaince = (key, nameColums, newValue) => {
    const index = listPlanMaintenance.findIndex((item) => item.key === key);
    const newObject = {
      [nameColums]: newValue,
    };

    const newDataSource = [
      ...listPlanMaintenance.slice(0, index),
      { ...listPlanMaintenance[index], ...newObject },
      ...listPlanMaintenance.slice(index + 1),
    ];
    setListPlanMaintenance(newDataSource);
    setIsDirty(true)
  };
  const getGene = () => {
    if(mode === MODE_SCREEN.ADD)return 1;
    return currentGene
    }
  const handleAddRowPlanMaintaince = () => {
    const key = Date.now();
    const newRow = {
      key,
      machineForSiteOfficeCode: "",
      dateImplementation: "",
      division: "",
      overview: "",
      workContent: "",
      contractor: "",
      repairFrequency: "",
      generationNumber:getGene()
    };
    setListPlanMaintenance([newRow,...listPlanMaintenance]);
  };
  const isReadOnlyRole = roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER";
  const getValueRepair = (value) => {
    if (!value || value === "0") {
      return "セットなし";
    }
    const item = optionRepair.find((i) => i.value == value);
    if (item) {
      return item.label;
    }
  };
  const isError = (data, {generationNumber,...row}) =>
  {
   return  isEmptyData(data) && clickSave && filterEmptyDataSource(row);
  }
  const column_plan_maintaince_history = [
    !isViewMode && {
      title: " ",
      dataIndex: "delete",
      width: "5%",
      align: "center",
      render: (_, row) => (
        <Button
          hidden={isReadOnlyRole}
          style={{ background: "#f7f9fc" }}
          onClick={() => handleDeleteRowPlanMaintaince(row.key)}
          icon={<DeleteOutlined />}
        />
      ),
    },
    {
      title: "世代番号",
      dataIndex: "generationNumber",
      width: 100,
      align: "center",
      type:"number"
    },

    {
      title: <span style={{ color: "#ff2255" }}>{lang.MAINTAINCE_DATE}</span>,
      dataIndex: "dateImplementation",
      key: "dateImplementation",
      width: "165px",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{_ ? moment(_).format("YYYY/MM/DD") : ""}</span>
        ) : (
          <DatePicker
            format={KEY.DATE_DEFAULT}
            value={moment(_).isValid() ? moment(_) : null}
            className={isError(_, row) ? STYLE.BORDER_RED + " w100" : "w100"}
            disabledDate={(current) => current < moment().startOf("day")}
            placeholder=""
            onChange={(v) =>
              onChangePlanMaintaince(row.key, "dateImplementation", v)
            }
          />
        ),
    },

    {
      title: lang.MAINTAINCE_DIVISION,
      key: "division",
      width: "15%",
      align: "center",
      dataIndex: "division",
      render: (_, row) =>
        isViewMode ? (
          <span>{_}</span>
        ) : (
          <Input
            value={_}
            onChange={(e) =>
              onChangePlanMaintaince(row.key, "division", e.target.value)
            }
          />
        ),
    },

    {
      title: (
        <>
          <span style={{ color: "#ff2255" }}>{lang.MAINTAINCE_PIC}</span>

          {!isViewMode && (
            <ButtonModalClassification callback={fetchClassification} />
          )}
        </>
      ),
      key: "contractor",
      width: "15%",
      align: "center",
      dataIndex: "contractor",
      render: (_, row) =>
        isViewMode ? (
          <span>{row.contractorValue}</span>
        ) : (
          <Select
            onChange={(value) =>
              onChangePlanMaintaince(row.key, "contractor", value)
            }
            value={_}
            className={isError(_, row) ? STYLE.BORDER_RED + " w100" : "w100"}
          >
            {ddlClassification.options.map((item) => (
              <Select.Option key={item.id} value={item.value}>
                <div
                  className="mr8"
                  style={{
                    width: 14,
                    height: 14,
                    borderRadius: "50%",
                    backgroundColor: item.color,
                    display: "inline-block",
                  }}
                ></div>
                {item.classification}
              </Select.Option>
            ))}
          </Select>
        ),
    },

    {
      title: (
        <span style={{ color: "#ff2255" }}>{lang.MAINTAINCE_OVERVIEW}</span>
      ),
      key: "overview",
      dataIndex: "overview",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{_}</span>
        ) : (
          <Input
            className={isError(_, row) ? STYLE.BORDER_RED + " w100" : "w100"}
            value={_}
            onChange={(e) =>
              onChangePlanMaintaince(row.key, "overview", e.target.value)
            }
          />
        ),
    },

    {
      title: (
        <span style={{ color: "#ff2255" }}>{lang.MAINTAINCE_WORK_CONTENT}</span>
      ),
      key: "workContent",
      dataIndex: "workContent",
      align: "center",
      render: (_, row) =>
        isViewMode ? (
          <span>{_}</span>
        ) : (
          <TextArea
            className={isError(_, row) ? STYLE.BORDER_RED + " w100" : "w100"}
            rows={1}
            value={_}
            onChange={(e) =>
              onChangePlanMaintaince(row.key, "workContent", e.target.value)
            }
          />
        ),
    },

    {
      title: "修理頻度",
      dataIndex: "repairFrequency",
      key: "repairFrequency",
      width: "155px",
      align: "center",
      render: (value, row) =>
        isViewMode ? (
          <span>{getValueRepair(value)}</span>
        ) : (
          <Select
            defaultValue={value}
            onChange={(e) => {
              onChangePlanMaintaince(row.key, "repairFrequency", e);
            }}
            options={optionRepair}
            style={{ width: 135 }}
          />
        ),
    },

    // Cột thêm dòng lập kế hoạch – ẩn nếu là VIEW
    !isViewMode && {
      title: "",
      dataIndex: "",
      key: "",
      width: "105px",
      align: "center",
      render: (value, row) => (
        <Button
          hidden={isReadOnlyRole}
          className="buttonPC button--outline --todo-- wAuto"
          onClick={() => {
            handleAddRowMaintaince(row);
            if(row.dateImplementation){
              onChangePlanMaintaince(
                row.key,
                "dateImplementation",
                moment(row.dateImplementation).add(row.repairFrequency, "M")
              );
            }
            
          }}
        >
          <ToTopOutlined
            className="orange"
            style={{ fontSize: "28px", cursor: "pointer" }}
          />
        </Button>
      ),
    },
  ].filter(Boolean);
  async function fetchClassification(value) {
    try {
      const res = await API.getClassification();
      if (res && !isEmpty(res.data)) {
        setDdlClassification({
          ...ddlClassification,
          options: res.data.map((item) => ({
            ...item,
            label: item.classification,
            value: item.id,
          })),
        });
      }
    } catch (e) {}
  }
  return (
    <div>
      {mode !== MODE_SCREEN.VIEW && (
        <div className="mt8">
          <Button
            hidden={roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER"}
            style={{
              background: "#f7f9fc",
              width: "auto",
              minWidth: "auto",
            }}
            className="pr10 pl10 mt4 mb4 ml10"
            onClick={() => handleAddRowPlanMaintaince()}
            icon={<PlusOutlined />}
          />
        </div>
      )}
      <Table
        scroll={!isEmpty(listPlanMaintenance) && { y: 220, x: 1000 }}
        locale={{
          emptyText: "",
        }}
        pagination={false}
        dataSource={listPlanMaintenance}
        className="tableAddMachine"
        columns={column_plan_maintaince_history}
      />
      
    </div>
  );
};

export default EquipmentRepairPlan;
